﻿import { NRECT } from "../util/classes";
export class CANVAS {

    public static ExactGetClientRect_V2(canvas_element: HTMLCanvasElement, r: NRECT): void {
        r.left = 0;
        r.top = 0;
        r.right = canvas_element.width;
        r.bottom = canvas_element.height;
    }



    public static ExactPaintRECT(ctx: CanvasRenderingContext2D, r: NRECT, color: string): void {
        const r_width = r.GetWidth();
        const r_height = r.GetHeight();
        ctx.fillStyle = color;
        ctx.fillRect(r.left, r.top, r_width, r_height);
    }
}

